package com.alpha.showcase.common.cache

import androidx.room3.RoomDatabaseConstructor

public actual object SourceCacheDatabaseConstructor : RoomDatabaseConstructor<SourceCacheDatabase> {
  actual override fun initialize(): SourceCacheDatabase = com.alpha.showcase.common.cache.SourceCacheDatabase_Impl()
}
